import moment from 'moment';

export const sleep = ms => {
    return new Promise(resolve => {
        setTimeout(() => {
            resolve()
        }, ms)
    })
}

export const pascal = string => {
    const splt = string.split('_')
    return splt.reduce((pre, cur, i) => `${i === 0 ? '' : `${pre} `}${cur.slice(0, 1).toUpperCase()}${cur.slice(1)}`, '')
}

export const IsValidEmail = (email) => {
    const reEmail = /^(?:[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+\.)*[\w\!\#\$\%\&\'\*\+\-\/\=\?\^\`\{\|\}\~]+@(?:(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!\.)){0,61}[a-zA-Z0-9]?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9\-](?!$)){0,61}[a-zA-Z0-9]?)|(?:\[(?:(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\.){3}(?:[01]?\d{1,2}|2[0-4]\d|25[0-5])\]))$/;
    return email.match(reEmail)
}

export const getYearRange = (start) => {
    const range = []
    while (start <= moment().format('YYYY-01-01')) {
        range.push(start)
        start = moment(start).add(1, 'year').format('YYYY-01-01')
    }
    return range
}

export const getMonthRange = (start, end) => {
    const range = []
    while(start <= end) {
        range.push(start)
        start = moment(start).add(1, 'month').format('YYYY-MM-DD')
    }
    return range
}
